import React from 'react';
import { Text } from '@chakra-ui/react';
import { localise } from '../../../services/lang/lang';
import PanelContainerWithFallback from './PanelContainerWithFallback';
const HazardsPanel = ({ hazards }) => {
    const hazardString = hazards.map((h) => h.name).join(', ');
    return (React.createElement(PanelContainerWithFallback, { condition: !!hazards.length, fallbackText: localise('NONE_ADDED'), title: `${localise('HAZARDS')}:`, "data-testid": "hazards_panel" },
        React.createElement(Text, { variant: "md-600-rg-4", as: "span", wordBreak: "keep-all", noOfLines: 5, "data-testid": "hazards_panel__hazards", whiteSpace: "normal" }, hazardString)));
};
export default HazardsPanel;
